import {
  modifyLinks,
  textAlign,
  textAlignMarginLeft,
  textAlignMarginRight,
} from '../../util/DataUtil';

const Title = ({ title, position, emphasizedTextColor }) => {
  return (
    <span
      className={`title ${emphasizedTextColor ? emphasizedTextColor : ''}`}
      dangerouslySetInnerHTML={{ __html: modifyLinks(title) }}
      style={{
        marginLeft: textAlignMarginLeft(position),
        marginRight: textAlignMarginRight(position),
        textAlign: textAlign(position),
      }}
    />
  );
};

export default Title;
